module.exports = __webpack_public_path__ + "static/Katharina_Hochmuth-BfA_600.617683dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutMaterialDownload/images/Katharina_Hochmuth-BfA_600.jpg
// module id = 411
// module chunks = 35783957827783